/* ============================================================================
   KIVORA v6.9.1 — el aviso de disponibilidad sigue al selector de variante.

   Se carga solo en la ficha de producto y no toca kivora-system.js. Un unico
   listener delegado en el documento: si el selector de variante cambia, se
   repinta el aviso con el que ya venia impreso desde Liquid en la opcion
   elegida. Sin peticiones, sin estado propio, sin datos inventados.

   Si este archivo no llega a ejecutarse, la pagina sigue funcionando: el
   aviso se queda con el de la variante que Shopify sirvio de inicio, que es
   correcto para el 100% de los productos de una sola variante.
   ========================================================================== */
(function () {
  'use strict';

  function paint(select) {
    var chosen = select.options[select.selectedIndex];
    if (!chosen) { return; }

    /* v6.13: acotado a la .shopify-section del selector; sin ambito, una
       pagina con varios productos veia pisados el precio y el aviso de los
       demas al cambiar la variante de uno. */
    var scope = (select.closest && select.closest('.shopify-section')) || document;

    /* v6.9.5: querySelector solo pintaba el PRIMER aviso; si la pagina lo
       repite (barra pegajosa, landing), se actualizan todos. */
    var stockHtml = chosen.getAttribute('data-stock');
    if (stockHtml !== null) {
      var stocks = scope.querySelectorAll('[data-variant-stock]');
      for (var i = 0; i < stocks.length; i++) { stocks[i].innerHTML = stockHtml; }
    }

    /* v6.14: el repintado del precio se retiro de aqui. kivora-system.js
       (kv-variants.sync, acotado a la seccion desde v6.9.5) ya escribe TODOS
       los [data-variant-price]: mantener dos escritores del mismo nodo era
       trabajo duplicado y dos fuentes de verdad. Este archivo conserva lo
       unico que nadie mas pinta: el aviso de stock. */
  }

  document.addEventListener('change', function (e) {
    var el = e.target;
    if (!el || !el.matches || !el.matches('select[data-variant-select]')) { return; }
    paint(el);
  });
})();
